(function () {
  'use strict';
  if (window.AudelvynCart) { return; }
  var lastFocus = null;

  function drawer() { return document.getElementById('av-cart-drawer'); }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function h(tag, props, kids) {
    var node = document.createElement(tag);
    Object.keys(props || {}).forEach(function (key) {
      var val = props[key];
      if (val === false || val === null || val === undefined) { return; }
      if (key === 'text') { node.textContent = val; }
      else if (key === 'class') { node.className = val; }
      else { node.setAttribute(key, val === true ? '' : val); }
    });
    (kids || []).forEach(function (kid) { if (kid) { node.appendChild(kid); } });
    return node;
  }

  function sized(url, width) {
    if (!url) { return ''; }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function getJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  function showError(message) {
    var d = drawer();
    var node = d && d.querySelector('[data-av-error]');
    if (!node) { return; }
    node.textContent = message || '';
    node.hidden = !message;
  }

  function setBusy(on) {
    var d = drawer();
    if (!d) { return; }
    d.classList.toggle('is-busy', on);
    d.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function line(item, index, currency) {
    var media = item.image
      ? h('img', { src: sized(item.image, 160), alt: (item.featured_image && item.featured_image.alt) || '', width: 80, height: 80, loading: 'lazy' })
      : h('span', { class: 'av-line-noimg' });
    var info = [h('a', { class: 'av-line-title', href: item.url, text: item.product_title })];
    if (item.variant_title && item.variant_title !== 'Default Title') {
      info.push(h('p', { class: 'av-line-meta', text: item.variant_title }));
    }
    info.push(h('p', { class: 'av-line-price', text: money(item.final_line_price, currency) }));
    var minus = h('button', { type: 'button', class: 'av-step', 'data-av-step': '', 'data-dir': 'minus', 'data-line': index, 'data-qty': item.quantity - 1, 'aria-label': 'Decrease quantity of ' + item.product_title, text: '−' });
    var input = h('input', { type: 'number', class: 'av-qty', min: '0', value: item.quantity, inputmode: 'numeric', 'data-av-qty': '', 'data-line': index, 'aria-label': 'Quantity for ' + item.product_title });
    var plus = h('button', { type: 'button', class: 'av-step', 'data-av-step': '', 'data-dir': 'plus', 'data-line': index, 'data-qty': item.quantity + 1, 'aria-label': 'Increase quantity of ' + item.product_title, text: '+' });
    var remove = h('button', { type: 'button', class: 'av-remove', 'data-av-remove': '', 'data-line': index, 'aria-label': 'Remove ' + item.product_title + ' from cart', text: 'Remove' });
    info.push(h('div', { class: 'av-line-controls' }, [h('div', { class: 'av-stepper' }, [minus, input, plus]), remove]));
    return h('li', { class: 'av-line' }, [media, h('div', { class: 'av-line-info' }, info)]);
  }

  function render(cart) {
    var d = drawer();
    if (!d) { return; }
    var body = d.querySelector('[data-av-cart-body]');
    var foot = d.querySelector('[data-av-cart-footer]');
    var active = document.activeElement;
    var focusKey = null;
    if (active && body.contains(active)) {
      focusKey = {
        line: active.getAttribute('data-line'),
        kind: active.hasAttribute('data-av-remove') ? 'remove' : (active.hasAttribute('data-av-qty') ? 'qty' : active.getAttribute('data-dir'))
      };
    }
    document.querySelectorAll('[data-av-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
    body.textContent = '';
    if (!cart.items.length) {
      body.appendChild(h('div', { class: 'av-empty' }, [
        h('p', { class: 'av-empty-title', text: 'Your cart is empty' }),
        h('a', { class: 'av-btn av-btn-dark', href: body.getAttribute('data-shop-url') || '/', text: 'Continue shopping' })
      ]));
      foot.hidden = true;
    } else {
      var list = h('ul', { class: 'av-line-list', role: 'list' });
      cart.items.forEach(function (item, i) { list.appendChild(line(item, i + 1, cart.currency)); });
      body.appendChild(list);
      d.querySelector('[data-av-total]').textContent = money(cart.total_price, cart.currency) + ' ' + cart.currency;
      foot.hidden = false;
    }
    if (focusKey) {
      var selector = focusKey.kind === 'remove' ? '[data-av-remove]' : (focusKey.kind === 'qty' ? '[data-av-qty]' : `[data-av-step][data-dir='${focusKey.kind}']`);
      var node = body.querySelector(`${selector}[data-line='${focusKey.line}']`);
      var fallback = body.querySelector('a[href],button,input') || d.querySelector('[data-av-close-btn]');
      var target = node || fallback;
      if (target) { target.focus(); }
    }
  }

  function refresh() {
    setBusy(true);
    return getJSON('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { throw new Error('Could not load your cart.'); }
        render(r.data);
        showError('');
      })
      .catch(function (err) { showError(err.message || 'Could not load your cart.'); })
      .then(function () { setBusy(false); });
  }

  function open() {
    var d = drawer();
    if (!d) { return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('av-lock');
    var closeButton = d.querySelector('[data-av-close-btn]');
    window.setTimeout(function () { if (closeButton) { closeButton.focus(); } }, 30);
  }

  function close() {
    var d = drawer();
    if (!d) { return; }
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('av-lock');
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function change(lineNumber, quantity) {
    setBusy(true);
    return getJSON('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(lineNumber), quantity: Math.max(0, Number(quantity) || 0) })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error(r.data && r.data.description ? r.data.description : 'Could not update your cart.'); }
        render(r.data);
        showError('');
        setBusy(false);
      })
      .catch(function (err) {
        return refresh().then(function () { showError(err.message); });
      });
  }

  function add(payload) {
    var isForm = typeof FormData !== 'undefined' && payload instanceof FormData;
    var options = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (isForm) {
      options.body = payload;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({ items: [payload] });
    }
    return getJSON('/cart/add.js', options).then(function (r) {
      if (!r.ok) {
        var message = r.data && (r.data.description || r.data.message);
        throw new Error(message || 'Could not add this item to your cart.');
      }
      return refresh().then(function () { open(); });
    }).catch(function (err) {
      return refresh().then(function () { open(); showError(err.message); });
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target.closest('[data-av-cart-open],[data-av-close],[data-av-step],[data-av-remove],[data-av-add],[data-av-menu]') : null;
    if (!target) { return; }
    if (target.hasAttribute('data-av-cart-open')) {
      event.preventDefault();
      open();
      refresh();
    } else if (target.hasAttribute('data-av-close')) {
      close();
    } else if (target.hasAttribute('data-av-step')) {
      change(target.getAttribute('data-line'), target.getAttribute('data-qty'));
    } else if (target.hasAttribute('data-av-remove')) {
      change(target.getAttribute('data-line'), 0);
    } else if (target.hasAttribute('data-av-add')) {
      var id = target.getAttribute('data-variant-id');
      if (!id || target.disabled) { return; }
      event.preventDefault();
      target.disabled = true;
      target.setAttribute('aria-busy', 'true');
      add({ id: Number(id), quantity: 1 }).then(function () {
        target.disabled = false;
        target.removeAttribute('aria-busy');
      });
    } else if (target.hasAttribute('data-av-menu')) {
      var panel = document.getElementById('av-mobile-nav');
      var expanded = target.getAttribute('aria-expanded') === 'true';
      target.setAttribute('aria-expanded', String(!expanded));
      if (panel) { panel.hidden = expanded; }
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-av-qty]')) {
      change(target.getAttribute('data-line'), target.value);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(`form[action*='/cart/add']`)) { return; }
    if (event.defaultPrevented) { return; }
    if (event.submitter && event.submitter.hasAttribute('data-av-buy-now')) { return; }
    event.preventDefault();
    add(new FormData(form));
  });

  document.addEventListener('keydown', function (event) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) { return; }
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') { return; }
    var nodes = Array.prototype.filter.call(
      d.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'),
      function (node) { return node.offsetParent !== null; }
    );
    if (!nodes.length) { return; }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('scroll', function (event) {
    var header = document.querySelector('[data-av-header]');
    if (!header) { return; }
    var source = event.target;
    var offset = source === document ? window.scrollY : (source.scrollTop || 0);
    header.classList.toggle('is-stuck', offset > 8);
  }, { capture: true, passive: true });

  function init() {
    var header = document.querySelector('[data-av-header]');
    if (header && !header.dataset.ready) {
      header.dataset.ready = 'true';
      var wrap = header.closest('.shopify-section');
      if (wrap) { wrap.classList.add('av-sticky'); }
    }
    refresh();
  }

  window.AudelvynCart = { open: open, close: close, refresh: refresh, add: add };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
